(function () {
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!form.matches('[data-ll-exact-search]')) return;

    var value = event.formData.get('q');
    if (typeof value !== 'string') return;
    var model = value.replace(/["\\]/g, '').replace(/\s+/g, ' ').trim();
    if (!model) return;

    event.formData.set('q', 'title:"' + model + '"');
  }, true);
})();
